import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Comments from "./Comments"; 
import parrot1 from "../images/parrot1.jpeg";
import parrot2 from "../images/parrot2.jpg";
import "./Parrot.css";

function Parrot() {
  return (
    <div className="parrot-page">
      

      <main className="parrot-content">
        <section className="parrot-hero">
          <h2>Parrots</h2>
          <p>
            Parrots are colorful birds known for their intelligence and ability to mimic sounds.
          </p>
        </section>

        <section className="parrot-images">
          <img src={parrot1} alt="Parrot 1" />
          <img src={parrot2} alt="Parrot 2" />
        </section>

        <section className="parrot-info">
          <h3>Locations</h3>
          <p>
            Parrots are found worldwide in tropical and subtropical regions, 
            especially in rainforests and warm climates.
          </p>
        </section>
      </main>

      {/* ✅ Comments connected to MongoDB */}
      <Comments apiEndpoint="http://localhost:5000/api/parrot-comments" />

    
    </div>
  );
}

export default Parrot;


